import "./OurInitiatives.css";
import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal3 from "../../components/Modal3";

const OurInitiatives = () => {
  const modalData = [
    {
      name: "Mihir Nerurkar",
      img: "/assets/limg1.jpg",
      title: "MD COO India\nBrookfield Infrastructure Group",
      about:
        "Mihir Nerurkar is the Managing Director and Operating Partner, of Brookfield’s Infrastructure Group for India. In this role, he oversees operations of all infrastructure assets and the overall performance of Brookfield’s infrastructure portfolio companies in India. Mr. Nerurkar joined Brookfield in 2018 with over 20 years of experience across the financial services, real estate, and infrastructure sectors. He began his career as a Management Consultant with Deloitte Consulting in New York and subsequently held roles as Chief Operating Officer and Senior Director at a real estate firm, as well as served as an Advisory Board Member of a boutique investment bank.\n\nHe holds a Bachelor of Engineering from Pune University in India and a Master’s from Syracuse University",
    },

    {
      name: "Gaurav Chowdhary",
      img: "/assets/limg3.jpg",
      title: "Vice President Investments\nBrookfield Advisors India Pvt Ltd",
      about:
        "Gaurav Chowdhary is a Vice President of Brookfield’s Infrastructure Group. He is a part of the team managing the investment activity in India & Middle East. Mr. Chowdhary has completed his PGDBM from XLRI Jamshedpur and a Bachelor’s degree from IIT Kharagpur.",
    },
  ];
  const [modals, setModals] = useState([]);

  useEffect(() => {
    setModals(modalData.map((modal) => ({ ...modal, isOpen: false })));
  }, []);

  const setModalState = (index, isOpen) => {
    const updatedModals = [...modals];
    updatedModals[index].isOpen = isOpen;
    setModals(updatedModals);
  };

  const openModal = (index) => {
    setModalState(index, true);
  };

  const closeModal = (index) => {
    setModalState(index, false);
  };

  return (
    <div>
      <div className="hero_img initiative_hero_img">
        <img src="/assets/csr_banner.jpg" alt="" />

        <div className="hero_title">Our Impact Stories</div>
      </div>
      <div className="container2">
        <div className="init_flex2 portp_div2 container ">
          <div className=" init_imgdiv">
            <img src="/assets/OurInitiatives/OurInitiativesimg2.jpg" alt="" />
          </div>
          <div className="portp_div21  init_div ">
            <h2>Our Impact Stories</h2>
            <p>
              At Crest Digitel, we believe that doing business responsibly and
              sustainably is crucial for building long-term growth and
              stakeholder value. As the digital landscape is fast expanding
              globally and touching lives in different ways, we are aligning our
              sustainability strategy with our innovations in the digital
              infrastructure space.
            </p>
            <div>
              <div className="intitiative_div211">
                <h6>Our CSR Vision</h6>
                <p>Enriching lives to create a positive social impact</p>
              </div>
              <div className="intitiative_div211">
                <h6>Our CSR Mission</h6>
                <p>
                  Creating connected experiences for our communities through
                  sustainable initiatives to work on the well-being of the
                  community with utmost integrity towards all our people,
                  partners, customers and the environment.
                </p>
              </div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="/assets/OurInitiatives/CrestDigitel-CSR-Policy.pdf"
                className="policies_link"
              >
                Download CSR Policy
              </a>
            </div>
          </div>
        </div>
        <div className="intitiative_div3 init_h container">
          <h3>Our Focus Areas</h3>
          <p>
            We commit to positively impacting and influencing society for its
            sustainable development. It is always our endeavor to raise the
            community standards in the area we operate in by focusing on
            supporting:
          </p>
          <div className="intitiative_div31">
            <div className="intitiative_div311">
            <div className="intitiative_div311_img">
                <img
                  src="/assets/OurInitiatives/OurInitiativesimg3.jpg"
                  alt=""
                />
              </div>
              <span>Education</span>
              <p className="p_init">
                Quality education with a special focus on the girl child by
                adopting schools and working with consistency and ensuring
                sustenance.
              </p>
            </div>
            <div className="intitiative_div311">
            <div className="intitiative_div311_img">
                <img
                  src="/assets/OurInitiatives/OurInitiativesimg4.jpg"
                  alt=""
                />
              </div>
              <span>Livelihood</span>
              <p>
                Enabling livelihood opportunities for the girl students through
                skill development programs.
              </p>
            </div>
            <div className="intitiative_div311">
              <div className="intitiative_div311_img">
                <img
                  src="/assets/OurInitiatives/OurInitiativesimg5.jpg"
                  alt=""
                />
              </div>
              <span>Healthcare</span>
              <p>
                Access to Healthcare through financial support and other health
                initiatives & programs for hospitals in less privileged areas.
              </p>
            </div>
          </div>
        </div>

        <div className="init_flex">
          <div className="lpage_heading1 init_h">
            <h3>
              Key Projects <br />
              (2022-23)
            </h3>
          </div>
          <div className="init_flex2 portp_div2 container init_pad">
            <div className="portp_div31  ">
              <img src="/assets/OurInitiatives/OurInitiativesimg6.jpg" alt="" />
            </div>
            <div className="portp_div21 init_div2">
              <div>
                <p className="pad_div">A Quality Education Program</p>
                <h2>SATYA BHARTI SCHOOL</h2>
              </div>

              <p>
                At Crest Digitel, we believe that doing business responsibly and
                sustainably is crucial for building long-term growth and
                stakeholder value. As the digital landscape is fast expanding
                globally and touching lives in different ways, we are aligning
                our sustainability strategy with our innovations in the digital
                infrastructure space.
              </p>
              <p>
                The Satya Bharti School Program is the flagship initiative of
                the Bharti Foundation aimed at providing quality education to
                underprivileged children, completely free of cost, with a
                special focus on the girl child in rural areas of India.
              </p>
            </div>
          </div>
        </div>

        <div className="portp_div2 container init_pad">
          <div className="portp_div21 init_div2">
            <div>
              <p className="pad_div">A Skill Development Program</p>
              <h2>Project YUKTI</h2>
            </div>

            <p>
              Crest Digitel Private Limited in collaboration with ANK has
              started “Project Yukti” at Sarhaul Gurugram for marginalized girl
              students. “Yukti” Stands for Skill Development, this project
              focuses on enhancing the students’ skill sets by providing
              training in MS Office and Digital Marketing, thus enhancing their
              skills for better livelihood opportunities.
            </p>
            <p>
              ANK is a non-governmental and non-profit organization (NGO) that
              supports quality education and employability to build better
              livelihood opportunities for rural and underprivileged urban
              youth.
            </p>
          </div>
          <div className="portp_div31 ">
            <img src="/assets/OurInitiatives/OurInitiativesimg7.jpg" alt="" />
          </div>
        </div>
        <div className="init_flex2 portp_div2 container init_pad">
          <div className="portp_div31 ">
            <img src="/assets/OurInitiatives/OurInitiativesimg8.jpg" alt="" />
          </div>
          <div className="portp_div21 init_div2">
            <div>
              <p className="pad_div">A Healthcare Program</p>
              <h2>Inali Foundation</h2>
            </div>

            <p>
              We continuously strive to improve the quality of life in the
              communities where we operate, which is congruent with our CSR
              Vision. We collaborated with the Inali Foundation to provide free
              prosthetic arms to beneficiaries from various regions,
              representing a wide range of ages and socioeconomic backgrounds,
              who had lost their hand/s due to unforeseen circumstances.
            </p>
            <p>
              The battery-powered prosthetic arms are designed to help people
              restore their mobility by helping them with everyday chores such
              as holding a pen, drinking water, driving, or lifting weights up
              to 8kg.
            </p>
            <p>
              By providing a helping hand to the amputees’ Crest aims to build a
              better and more inclusive society and transform lives.
            </p>
          </div>
        </div>

        <div className="init_flex">
          <div className="lpage_heading1 init_h">
            <h3>CSR Board</h3>
          </div>
          <div className="lpage_div1">
            <Link onClick={() => openModal(0)}>
              <div className="lpage_div11">
                <img src="/assets/leadimg2.jpg" alt="" />
                <div className="lpage_div1_title">
                  <span>Mihir Nerurkar</span>
                  <p>MD & COO India</p>
                  <p>Brookfield Infrastructure Group</p>
                </div>
              </div>
            </Link>

            {/* <div className="lpage_div12 lpage_div11">
              <img src="/assets/leadimg3.jpg" alt="" />
              <div className="lpage_div1_title">
                <span>Arushi Jamar</span>
                <p>Senior Vice President - HR</p>
                <p>Brookfield Asset Management</p>
              </div>
            </div> */}
            <Link onClick={() => openModal(1)}>
              <div className="lpage_div13 lpage_div11">
                <img src="/assets/leadimg4.jpg" alt="" />
                <div className="lpage_div1_title">
                  <span>Gaurav Chowdhary</span>
                  <p>Vice President Investments</p>
                  <p>Brookfield Infrastructure Group</p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
      {modals.map(
        (modal, index) =>
          modal.isOpen && (
            <Modal3
              key={index}
              closeModal={() => closeModal(index)}
              img={modal.img}
              title={modal.title}
              name={modal.name}
              about={modal.about}
            />
          )
      )}
    </div>
  );
};

export default OurInitiatives;
